const spaceRouterList = [
  {
    path: "/blackboard",
    name: 'blackboardGame',
    meta: {
      title: '游戏',
      isLogin: false
    },
    component: () => import('../views/mobile-space/index.vue')
  },{
    path: "/blackboard/login",
    name: 'blackboardGameLogin',
    meta: {
      title: '游戏',
      isLogin: false
    },
    component: () => import('../views/blackboard/login/index.vue')
  }
]

export default spaceRouterList
